
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityService } from './entity.service';


@Injectable({
  providedIn: 'root'
})
export class EnergyMeterTypService extends EntityService {
  public entityRoute: any;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getEnergyMeterTyps(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/EnergyMeterType/getEnergyMeterTypes`);
  }
}
